var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9108_40412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4316 7.84287C30.4316 11.3082 27.6224 14.1174 24.1571 14.1174C20.6918 14.1174 17.8826 11.3082 17.8826 7.84287C17.8826 4.37755 20.6918 1.56836 24.1571 1.56836C27.6224 1.56836 30.4316 4.37755 30.4316 7.84287Z",
    stroke: "#4BDACC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4316 24.1566C30.4316 27.6219 27.6224 30.4311 24.1571 30.4311C20.6918 30.4311 17.8826 27.6219 17.8826 24.1566C17.8826 20.6913 20.6918 17.8821 24.1571 17.8821C27.6224 17.8821 30.4316 20.6913 30.4316 24.1566Z",
    stroke: "#4BDACC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1179 7.84287C14.1179 11.3082 11.3087 14.1174 7.84336 14.1174C4.37804 14.1174 1.56885 11.3082 1.56885 7.84287C1.56885 4.37755 4.37804 1.56836 7.84336 1.56836C11.3087 1.56836 14.1179 4.37755 14.1179 7.84287Z",
    stroke: "#4BDACC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1179 24.1566C14.1179 27.6219 11.3087 30.4311 7.84336 30.4311C4.37804 30.4311 1.56885 27.6219 1.56885 24.1566C1.56885 20.6913 4.37804 17.8821 7.84336 17.8821C11.3087 17.8821 14.1179 20.6913 14.1179 24.1566Z",
    stroke: "#4BDACC",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9108_40412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.7b1230dc03d285567f265eac51b8331a.svg";
export { ForwardRef as ReactComponent };